import {
  JsonViewer
} from "./chunk-6HJCMUMX.js";

// src/index.ts
customElements.define("json-viewer", JsonViewer);
